// The sections behind the API Integration modal's left-nav + right-panel redesign, one list per
// function type, mirroring promptHubSections.js's shape exactly. Each section's `fields` list is
// used to scope which fields get validated (trigger()) when that section's own "Save" button is
// clicked, and for the per-section save indicator. The backend's POST /api/apiFunction update
// branch is a full overwrite of the row, not a merge, so the request FunctionModal.js actually
// sends on Save always carries the function's complete current definition regardless of which
// section triggered it - see buildSectionPayload() in FunctionModal.js.
//
// "bulkUpload" (cold_transfer only) has no `fields` on purpose: it saves through its own dedicated
// endpoint (POST /api/apiFunction/bulkUploadColdTransfer via <ColdTransferCsvUpload>), and - same as
// today - is only offered while creating a brand new cold_transfer function, never while editing
// one that already exists.
const GENERAL_FIELDS = ["name", "description"];
const REQUEST_FIELDS = ["url", "requestType", "auth_header"];
const EXECUTION_SETTINGS_FIELDS = ["execution_mode", "timeout_sec", "retry_count", "periodic_message"];
const ROUTING_RULES_FIELDS = ["routing_rules"];
const ATTRIBUTES_FIELDS = ["attributes"];
const TRANSFER_DETAILS_FIELDS = ["handover_receiver_phone_number", "ext", "ext_delay_sec", "transfer_line"];
const WARM_SUMMARY_FIELDS = ["warm_summary_prompt"];
const NO_ANSWER_FIELDS = ["failure_mode", "failure_prompt"];

export const API_FUNCTION_SECTIONS = [
  { id: "general", label: "General", fields: GENERAL_FIELDS },
  { id: "request", label: "Request Settings", fields: REQUEST_FIELDS },
  { id: "executionSettings", label: "Execution Settings", fields: EXECUTION_SETTINGS_FIELDS },
  { id: "routingRules", label: "Routing Rules", fields: ROUTING_RULES_FIELDS },
  { id: "attributes", label: "Attributes", fields: ATTRIBUTES_FIELDS },
];

export const WARM_TRANSFER_SECTIONS = [
  { id: "general", label: "General", fields: GENERAL_FIELDS },
  { id: "transferDetails", label: "Transfer Details", fields: TRANSFER_DETAILS_FIELDS },
  { id: "warmSummary", label: "Warm Summary", fields: WARM_SUMMARY_FIELDS },
  { id: "noAnswer", label: "No Answer", fields: NO_ANSWER_FIELDS },
];

export const COLD_TRANSFER_SECTIONS = [
  { id: "general", label: "General", fields: GENERAL_FIELDS },
  { id: "transferDetails", label: "Transfer Details", fields: TRANSFER_DETAILS_FIELDS },
  { id: "bulkUpload", label: "Bulk Upload", fields: [] },
];

export const FUNCTION_SECTIONS_BY_TYPE = {
  apiFunction: API_FUNCTION_SECTIONS,
  warm_transfer: WARM_TRANSFER_SECTIONS,
  cold_transfer: COLD_TRANSFER_SECTIONS,
};

export const getFunctionSections = (functionType) =>
  FUNCTION_SECTIONS_BY_TYPE[functionType] || [];

export const findFunctionSection = (functionType, sectionId) =>
  getFunctionSections(functionType).find((section) => section.id === sectionId);
